(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name printer.factory:Printer
   *
   * @description
   *
   */
  angular
    .module('vcdms.vcdoctype')
    .factory('Printer', Printer)
    .factory('Printerlist', Printerlist);

  Printer.$inject = ['restmod'];

  function Printer(restmod) {
    return restmod.model('/routes/printer');
  }


  Printerlist.$inject = ['restmod'];

  function Printerlist(restmod) {
    let model = restmod.model('/routes/printer');
    let printers = {};
    function getPrinters() {
      return model.$search();
    }

    printers.getPrinters = getPrinters;
    printers.model = model;

    return printers;
  }

}());
